import { PriceFeedProviderConst } from "../price-feed-provider.lib";
import { Process } from "../../../../lib/process/process.cls";
export class SecurityMasterPatcher extends Process {
    /**
     * @Override
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    start(params) {
        this.log(SecurityMasterPatcher.TAG, 'start', params);
        this.settings = params;
    }
    /**
     * @Override
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    stop(params) {
        this.log(SecurityMasterPatcher.TAG, "stop done");
    }
    /**
     * @Override
     * authenticate
     * uses the credentials inside params in case auth is needed
     * @param params
     */
    auth(params) { }
    constructor(iProvider) {
        super(iProvider);
        // vuex store to make remote api calls
        this.vuexStore = null;
        this.vuexStore = iProvider.getStore();
        this.log(SecurityMasterPatcher.TAG, 'pid', this.settings.pid);
    }
    /**
     * decorate an expired cache item
     * @param iCacheable
     */
    decorate(iCacheable) {
        this.vuexStore.dispatch(PriceFeedProviderConst.RUN_LOAD_PATCH, {
            // to patch the right provider via mutation 
            cacheItemTag: this.iProvider.settings.cacheItemTag,
            // remote endpount
            target: this.settings.DW_HOST + this.settings.DW_EP_CLOSE_PRICE,
            // date format to compute yesterday
            dateformat: this.settings.DW_EP_CLOSE_PRICE_DF,
            // cache id
            key: iCacheable.key
        });
    }
}
SecurityMasterPatcher.TAG = 'SecurityMasterPatcher';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/patcher/security-master-patcher.cls.ts
// module id = null
// module chunks = 